import Vue from "vue";
import titleMixin from "@/mixins/title";
import spinnerMixin from "@/mixins/spinner";
export default Vue.extend({
    mixins: [titleMixin, spinnerMixin],
    data() {
        return {
            id: this.$route.params.id,
            title: this.$t("serviceCategories.edit.title", { name: "" }),
            data: {},
            validationOptions: {
                rules: {
                    name: {
                        required: true,
                        rangeLength: [3, 50]
                    },
                    description: {
                        maxLength: 255
                    }
                }
            }
        };
    },
    methods: {
        edit() {
            return this.$store.dispatch("serviceCategory/edit", {
                id: this.id,
                serviceCategory: this.data
            });
        },
        editSuccess() {
            this.$toast.showSuccessToast(this.$t("serviceCategories.edit.toastSuccessTitle"), this.$t("serviceCategories.edit.toastSuccessContent", {
                name: this.data.name
            }));
            return this.$router.push("/administration/service-categories");
        },
        cancel() {
            return this.$router.push("/administration/service-categories");
        }
    },
    async mounted() {
        this.showSpinner();
        try {
            this.data = await this.$store.dispatch("serviceCategory/get", {
                id: this.id
            });
            this.title = this.$t("serviceCategories.edit.title", { name: `${this.data.name}` });
        }
        catch (errors) {
            this.$toast.showDangerToast(this.$t("shared.toastFailureTitle"), this.$t("shared.toastFailureContent", {
                error: errors[0].message
            }));
            await this.$router.push("/administration/service-categories");
        }
        finally {
            this.hideSpinner();
        }
    }
});
